import { parseSvgStyle } from '@/icons/utils/svg-styles'
import { ISvgProps } from '@/icons/utils/svg-types'

export const SvgOutlinedPlace = (props: ISvgProps) => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={parseSvgStyle(props)}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 2.79706C8.63 2.79706 5.5 5.92706 5.5 9.79706C5.5 15.0471 12.5 22.7971 12.5 22.7971C12.5 22.7971 19.5 15.0471 19.5 9.79706C19.5 5.92706 16.37 2.79706 12.5 2.79706ZM7.5 9.79706C7.5 7.03706 9.74 4.79706 12.5 4.79706C15.26 4.79706 17.5 7.03706 17.5 9.79706C17.5 12.6771 14.62 16.9871 12.5 19.6771C10.42 17.0071 7.5 12.6471 7.5 9.79706ZM10 9.79706C10 8.41635 11.1193 7.29706 12.5 7.29706C13.3932 7.29706 14.2185 7.77356 14.6651 8.54706C15.1116 9.32056 15.1116 10.2736 14.6651 11.0471C14.2185 11.8206 13.3932 12.2971 12.5 12.2971C11.1193 12.2971 10 11.1778 10 9.79706Z"
                fill={props.color}
            />
        </svg>
    )
}
